export default "__VITE_ASSET__Mujz9qMF__"